$(function(){
    
    /* Video Modal */
    // On show add video src
    $('#videoModal').on('show.bs.modal', function (e) {
        var videoSrc = $(e.relatedTarget).data('video-src');
        var $videoFrame = $(this).find('.video-wrapper iframe');
        // Add video src in frame
        $videoFrame.attr('src', videoSrc);   
    })
    // On show add video src
    $('#videoModal').on('hidden.bs.modal', function (e) {
        var $videoFrame = $(this).find('.video-wrapper iframe');
        // Remove video src in frame to stop  the video from playing
        $videoFrame.attr('src', '');   
    })
    
});